"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _iconify = require("@iconify/react/dist/iconify.js");
var _material = require("@mui/material");
var _apiPostDeleteSummary = require("api/apiPostDeleteSummary");
var _clsx = require("clsx");
var _constants = require("util/constants");
var _Alerts = require("../../Alerts/Alerts");
var _DeleteModal = require("./DeleteModal.Utils");
var _useDeleteBlob = require("@/api/useDeleteBlob");
var _DeleteModalModule = _interopRequireDefault(require("./DeleteModal.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DeleteModal = exports.DeleteModal = function DeleteModal(_ref) {
  var callbackClose = _ref.callbackClose,
    documents = _ref.documents,
    selectedRows = _ref.selectedRows;
  var _usePostDeleteSummary = (0, _apiPostDeleteSummary.usePostDeleteSummary)(),
    callDeleteSummary = _usePostDeleteSummary.mutateAsync;
  var _useState = (0, _react.useState)(_constants.AlertColor.Info),
    _useState2 = _slicedToArray(_useState, 2),
    alertColor = _useState2[0],
    setAlertColor = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    alertMessage = _useState4[0],
    setAlertMessage = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var _usePostDeleteBlobs = (0, _useDeleteBlob.usePostDeleteBlobs)(),
    callDeleteBlobs = _usePostDeleteBlobs.mutateAsync;
  var deleteSummary = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _documents$map, _documents$map2, documentName, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (!(documents.length === 0)) {
              _context.next = 3;
              break;
            }
            throw new Error("There are no documents in array");
          case 3:
            _documents$map = documents.map(function (d) {
              return d.fileAlias;
            }), _documents$map2 = _slicedToArray(_documents$map, 1), documentName = _documents$map2[0];
            _context.next = 6;
            return callDeleteSummary((0, _DeleteModal.getDocumentName)(documentName));
          case 6:
            response = _context.sent;
            if (!(response.status != 200)) {
              _context.next = 9;
              break;
            }
            throw new Error("Failed to delete summary");
          case 9:
            return _context.abrupt("return", true);
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", false);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 12]]);
    }));
    return function deleteSummary() {
      return _ref2.apply(this, arguments);
    };
  }();
  var deleteBlob = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return callDeleteBlobs(documents.map(function (d) {
              return d.fileAlias;
            }));
          case 2:
            response = _context2.sent;
            if (!(response.status !== 200)) {
              _context2.next = 5;
              break;
            }
            throw new Error("Failed to delete blob");
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function deleteBlob() {
      return _ref3.apply(this, arguments);
    };
  }();
  var deleteDocuments = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var summaryDeleted;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setIsLoading(true);
            _context3.prev = 1;
            _context3.next = 4;
            return deleteSummary();
          case 4:
            summaryDeleted = _context3.sent;
            if (!summaryDeleted) {
              _context3.next = 11;
              break;
            }
            _context3.next = 8;
            return deleteBlob();
          case 8:
            callbackClose(true);
            _context3.next = 12;
            break;
          case 11:
            throw new Error("Failed to delete summary");
          case 12:
            _context3.next = 19;
            break;
          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](1);
            setAlertColor(_constants.AlertColor.Error);
            setAlertMessage("Unexpected error while trying to delete files from the storage.");
            setIsLoading(false);
          case 19:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 14]]);
    }));
    return function deleteDocuments() {
      return _ref4.apply(this, arguments);
    };
  }();
  var getSubmitButtonText = function getSubmitButtonText() {
    if (isLoading) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          padding: "0 10px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
        size: 15
      }), /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          marginLeft: 10
        }
      }, "Deleting..."));
    }
    if (selectedRows !== null && selectedRows !== void 0 && selectedRows.every(function (row) {
      return row.id.includes("".concat(_constants.TYPE_FOLDER, "-"));
    })) {
      return "Delete folder(s)";
    }
    if (selectedRows !== null && selectedRows !== void 0 && selectedRows.every(function (row) {
      return Number.isInteger(Number(row.id));
    })) {
      return "Delete file(s)";
    }
    return "Delete";
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Modal, {
    open: true,
    onClose: function onClose() {
      return callbackClose(false);
    },
    "data-testid": "modalDeleteFiles"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx.clsx)(_DeleteModalModule["default"].modal, "modal-kb-content")
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    onClick: function onClick() {
      return callbackClose(false);
    },
    className: _DeleteModalModule["default"].closeIcon
  }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
    icon: "bitcoin-icons:cross-filled",
    height: 30,
    color: "#000000"
  })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex gap-5 align-items-center "
  }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
    icon: "ep:warning",
    style: {
      color: "var(--black)",
      fontSize: "20px"
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: _DeleteModalModule["default"].title
  }, "Warning")), /*#__PURE__*/_react["default"].createElement("p", {
    className: _DeleteModalModule["default"].description
  }, "This action will delete all files contained within the selected item(s).")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-kb-footer"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "save_btn",
    onClick: deleteDocuments,
    disabled: isLoading,
    "data-testid": "deleteModal-deleteButton"
  }, getSubmitButtonText()), /*#__PURE__*/_react["default"].createElement("button", {
    className: "cancel_btn",
    onClick: function onClick() {
      return callbackClose(false);
    },
    "data-testid": "deleteModal-cancelButton",
    disabled: isLoading
  }, "Cancel")))), /*#__PURE__*/_react["default"].createElement(_Alerts.Alerts, {
    style: {
      top: "90%",
      right: "unset",
      left: "unset"
    },
    alertOpen: alertMessage !== "",
    color: alertColor,
    message: alertMessage,
    handleAlertClose: function handleAlertClose() {
      return setAlertMessage("");
    }
  }));
};